import { useState } from 'react'

import type { Gebied } from '@models/Gebied'

import { useAuthenticatedUser } from '../../../auth/hooks/useAuthenticatedUser'
import { useOrganisatiesByGebied } from '../../../projectdossier/hooks/useOrganisatiesByGebied'
import type { Projectdossier } from '../../../projectdossier/types/Projectdossier'
import type { Projectmelding } from '../../../projectmelding/types/Projectmelding'
import { useCreateProjectdossier } from '../../hooks/useCreateProjectdossier'

import { CreateProjectdossierForm } from './CreateProjectdossierForm'

interface Props {
  projectmelding?: Projectmelding
  onClose: () => void
  gebieden: Gebied[]
}

export const CreateProjectdossierDialog = ({
  projectmelding,
  onClose,
  gebieden,
}: Props) => {
  const { combi } = useAuthenticatedUser()

  const [gebiedscode, setGebiedscode] = useState(
    projectmelding?.contractGebiedCode,
  )

  const { data: organisaties, isLoading: isLoadingOrganisaties } =
    useOrganisatiesByGebied({ gebiedscode: gebiedscode || '' })

  const { mutate: createProjectdossier } = useCreateProjectdossier()

  const handleSubmit = (projectdossier: Partial<Projectdossier>) =>
    createProjectdossier({ projectdossier }, { onSuccess: () => onClose() })

  return (
    <CreateProjectdossierForm
      projectmelding={projectmelding}
      gebieden={gebieden}
      organisaties={organisaties}
      isLoadingOrganisaties={isLoadingOrganisaties}
      combi={combi}
      onGebiedscodeChange={setGebiedscode}
      onSubmit={handleSubmit}
      onClose={onClose}
    />
  )
}
